import type { PlatformPageFormValues } from "./types";
import type { PlatformPageType } from "@/types/graphql/partner.generated";

/**
 * Maps GraphQL PlatformPage data to form values
 */
export const mapPlatformPageToFormValues = (
  page: PlatformPageType
): PlatformPageFormValues => {
  return {
    title: page.title || "",
    path: page.path || "",
    description: page.description || null,
    imageId: page.image?.id || null,
    publishAt: page.publishAt || null,
    isHomepage: page.isHomepage || false,
    countryCodes: page.countryCodes || null,
    visibilityConditions: {
      userType: page.visibilityConditions?.userType || "ALL",
      countries: {
        type: page.visibilityConditions?.countries?.type || "ALL",
        countryCodes:
          page.visibilityConditions?.countries?.countryCodes || null,
      },
      applicationPlatforms: {
        type: page.visibilityConditions?.applicationPlatforms?.type || "ALL",
        platforms:
          page.visibilityConditions?.applicationPlatforms?.platforms || null,
      },
    },
    blocks:
      page.blocks?.map((block) => ({
        ...(block.id ? { _id: block.id } : {}),
        component: block.component,
        props: block.props || null,
        visibilityConditions: block.visibilityConditions
          ? {
              userType: block.visibilityConditions.userType || "ALL",
              countries: block.visibilityConditions.countries
                ? {
                    type: block.visibilityConditions.countries.type || "ALL",
                    countryCodes:
                      block.visibilityConditions.countries.countryCodes || null,
                  }
                : null,
              applicationPlatforms: block.visibilityConditions
                .applicationPlatforms
                ? {
                    type:
                      block.visibilityConditions.applicationPlatforms.type ||
                      "ALL",
                    platforms:
                      block.visibilityConditions.applicationPlatforms
                        .platforms || null,
                  }
                : null,
            }
          : null,
      })) || null,
  };
};
